import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { VoucherDownloadsTable } from './VoucherDownloadTable'
import Loader from '../../../common/components/Loader'
import { DownloadVouchers } from '../../../common/models/rewards'
import { useTableParams } from '../../../core/hooks/table-params'
import { getBatchVoucher } from '../../../core/services/voucher'
import { useAppSelector } from '../../../store'
import { MessageBox } from '../messages/MessageBox'
import { Header, PageTitle } from '@/components'
import { Card } from '@/components/ui'
import { Pagination } from '../Pagination'

export const DownloadsPage: React.FC = () => {
  const {
    page,
    setPage,
    size,
    setSize,
    totalElements,
    setTotalElemenets,
    sortBy,
    setSortBy,
  } = useTableParams({
    defaultSortBy: 'updatedAt',
  })

  const { editionId, festivalName } = useParams()
  const { festivals: storeFestivals } = useAppSelector((s) => s.app)
  const festivalFullName = storeFestivals.find(
    (f) => f.platformName === festivalName,
  )?.name

  const [vouchers, setVouchers] = useState<DownloadVouchers[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [isCheck, setIsCheck] = useState<string[]>([])

  const [isError, setIsError] = useState<boolean>(false)
  const [showMessageBox, setShowMessageBox] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')

  const getData = useCallback(async () => {
    try {
      setLoading(true)
      const request = await getBatchVoucher({ size, page })

      if (request.status === 200) {
        setVouchers(request.data.content)
        setTotalElemenets(request.data.totalElements)
      }
    } catch (e) {
      if (e instanceof Error) {
        setIsError(true)
        setShowMessageBox(true)
        setMessage(e.message)
      } else {
        console.error(e)
      }
    } finally {
      setLoading(false)
    }
  }, [size, page, sortBy, editionId, festivalName, setTotalElemenets])

  useEffect(() => {
    getData()
  }, [getData])

  return (
    <>
      <Header pageTitle="Rewards" />
      {loading && <Loader />}
      <Card className="p-5 !bg-monochrome-4-60">
        <PageTitle
          title="Rewards"
          subtitle="Voucher Downloads"
          className="mb-5"
        />
        <VoucherDownloadsTable
          vouchers={vouchers}
          page={page}
          setPage={setPage}
          size={size}
          setSize={setSize}
          sortBy={sortBy}
          setSortBy={setSortBy}
          totalElements={totalElements}
          setTotalElemenets={setTotalElemenets}
          withPagination={false}
          setIsCheck={setIsCheck}
          isCheck={isCheck}
        />
      </Card>
      <Pagination
        size={size}
        totalElements={totalElements}
        setSize={setSize}
        page={page + 1}
        changePage={setPage}
      />
      <MessageBox
        message={message}
        setShowMessageBox={setShowMessageBox}
        showMessageBox={showMessageBox}
        isError={isError}
      />
    </>
  )
}
